import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    commentRoot: {
      padding: 16,
      borderBottom: "1px solid #e6e6e6",
      "&:last-child": {
        borderBottom: "none"
      }
    },
    headerRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: 500,
      height: 22,
      color: primary.main,
      marginBottom: 6
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: 12,
      color: primary.dark,
      marginBottom: 5,
      textTransform: "capitalize"
    },
    commenterInfo: {
      display: "flex",
      alignItems: "center"
    },
    icon: {
      width: 13,
      marginRight: 8
    },
    commentContent: {
      fontSize: 12,
      color: "#333",
      lineHeight: "17px",
      wordBreak: "break-word"
    },
    colorFOT: {
      color: "#ff6363"
    }
  };
});
